import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAlbums } from '../thunks/albumThunks';

type Albums = {
    albumId: string;
    title: string;
    thumbnail: string;
    description: string;
    createdBy: string;
    usedToken: string;
    accessType: string;
    likes: number;
    tags: string[];
    sharedWith: string[];
    downloadable: boolean;
    status: string;
    createdAt: string;
    updatedAt: string;
};

interface AlbumState {
    list: {
        albums: Albums[];
        totalAlbums: number;
    };
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    errorMessage: string | null;
}

const initialState: AlbumState = {
    list: {
        albums: [],
        totalAlbums: 0,
    },
    status: 'idle',
    errorMessage: null,
};

const albumSlice = createSlice({
    name: 'albums',
    initialState,
    reducers: {
        addAlbum: (state, action: PayloadAction<Albums>) => {
            state.list.albums.push(action.payload);
            state.list.totalAlbums += 1;
        },
        resetAlbum: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAlbums.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAlbums.fulfilled, (state, action: PayloadAction<{ albums: Albums[], totalAlbums: number }>) => {
                state.status = 'succeeded';
                state.list = {
                    albums: action.payload.albums,
                    totalAlbums: action.payload.totalAlbums
                };
            })
            .addCase(fetchAlbums.rejected, (state, action) => {
                state.status = 'failed';
                state.errorMessage = (action.payload as string) ?? 'Something went wrong';
            });
    },
});

export const { addAlbum, resetAlbum } = albumSlice.actions;
export default albumSlice.reducer;
